import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/layout/Sidebar";
import { Topbar } from "@/components/layout/Topbar";
import { PageLoader } from "@/components/ui/Loader";

export function AdminLayout() {
  return (
    <div className="flex min-h-screen bg-slate-50 dark:bg-surface-dark">
      <Sidebar />
      <div className="flex flex-1 flex-col">
        <Topbar />
        {/* Capped width so forms don't stretch into unreadable line lengths on
            wide monitors, and stay centred when they don't fill it. */}
        <main className="flex-1 px-5 py-5">
          <div className="mx-auto w-full max-w-[1360px]">
            <Suspense fallback={<PageLoader />}>
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
    </div>
  );
}
